// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestSearchResults-cls1_onh","cls2":"ResearchInterestSearchResults-cls2__Sa ResearchInterestSearchResults-cls1_onh"};